import ButtonWrapper from '../../../components/button/button-wrapper/ButtonWrapper';
import { ActionButton, SecondaryButton } from '@sb1/ffe-buttons-react';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import {
    SHARE_PROJECT_HELP_TEXT_KEY,
    SHARE_PROJECT_TEXT_KEY,
    SUPPORT_PROJECT_TEXT_KEY,
} from '../../i18n/project-i18n-model';
import { NumberOfRecentTransactions } from '../number-of-recent-transactions/NumberOfRecentTransactions';

const PaymentButton = ({ navigateToPayment, supportButtonText, className }) => {
    const texts = useI18nTexts([SUPPORT_PROJECT_TEXT_KEY]);

    return (
        <ActionButton
            className={className}
            size="lg"
            onClick={() => {
                trackEvent('support', 'open', {
                    'button-text': supportButtonText || texts[SUPPORT_PROJECT_TEXT_KEY],
                    buttonType: 'main',
                });
                navigateToPayment();
            }}
            data-pay={true}
        >
            {supportButtonText || texts[SUPPORT_PROJECT_TEXT_KEY]}
        </ActionButton>
    );
};

const ShareButton = ({ sharePressed, shareButtonText, className }) => {
    const texts = useI18nTexts([SHARE_PROJECT_TEXT_KEY, SHARE_PROJECT_HELP_TEXT_KEY]);
    return (
        <>
            <SecondaryButton
                size="lg"
                onClick={() => {
                    trackEvent('share-project-modal', 'open-modal', {
                        'button-text': shareButtonText ?? texts[SHARE_PROJECT_TEXT_KEY],
                    });
                    sharePressed();
                }}
                aria-describedby={'share-button-sticky-description'}
                className={className}
                data-share={true}
            >
                {shareButtonText ?? texts[SHARE_PROJECT_TEXT_KEY]}
            </SecondaryButton>

            <ScreenReaderOnly id="share-button-sticky-description" tag={'span'}>
                {texts[SHARE_PROJECT_HELP_TEXT_KEY]}
            </ScreenReaderOnly>
        </>
    );
};

export const StandardSupportButtons = ({
    project,
    navigateToPayment,
    sharePressed,
    wrapperClass = '',
    buttonSecondaryClass = '',
    showShare = true,
    supportButtonText,
    showNumberOfRecentTransactions = true,
}) => {
    const showSharingButton = project?.profile?.showSharing && showShare;

    return (
        <ButtonWrapper className={wrapperClass}>
            <PaymentButton navigateToPayment={navigateToPayment} supportButtonText={supportButtonText} />
            {showSharingButton && (
                <ShareButton
                    sharePressed={sharePressed}
                    shareButtonText={project.profile?.shareButtonText}
                    className={buttonSecondaryClass}
                />
            )}
            {showNumberOfRecentTransactions && <NumberOfRecentTransactions />}
        </ButtonWrapper>
    );
};
